import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * MaskedReveal: renders text with each line inside an overflow-hidden mask
 * and translates from 100% -> 0% for a kinetic on-load moment.
 *
 * Accepts an array of lines or a single string.
 */
export default function MaskedReveal({
  lines,
  as: Tag = "h1",
  className = "",
  delay = 0,
  stagger = 0.09,
  duration = 0.85,
}) {
  const items = Array.isArray(lines) ? lines : [lines];

  return (
    <Tag className={cn("font-display leading-[0.95]", className)}>
      {items.map((line, i) => (
        <span
          key={i}
          className="mask-line"
          aria-hidden={i > 0 ? "true" : undefined}
        >
          <motion.span
            className="block will-change-transform"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              delay: delay + i * stagger,
              duration,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
